export const isNewBodyGym = (name?: string | null) =>
  !!name && name.toUpperCase().includes("NEW BODY");

export const KIOSKO_DOWNLOAD_URL =
  "https://esvhlvsfyrovwvkskfua.supabase.co/storage/v1/object/public/desktop-apps/clubbers-kiosko/ClubbersKiosko-win32-x64.zip";
